module.exports = __webpack_public_path__ + "img/auxano-mobile.c4621ef6.webp";